import { filter } from 'lodash-es';
import { getGroupByStores } from '../cache/store';
import { convertStoreScopesToIds } from '@knowledge/common/helpers/store';
import { ItemV5 } from '@knowledge/common/components/ItemSelectV5/Index';

type SearchParams = {
  name?: string;
  keyword: string;
  keywordType: number;
  storeScopes?: General.StoreScope[];
  tagIds?: string[];
  categoryUniqueIds?: string[];
};

const searchInSync = <T extends ItemSelectV2.Item>(
  items: T[],
  searchParams: Omit<SearchParams, 'storeScopes'>,
) => {
  const { name, keyword, keywordType, tagIds, categoryUniqueIds } = searchParams;
  // 模糊搜索
  if (name) {
    items = filter(items, (each) => {
      return each.itemName.toLowerCase().indexOf(name.toLowerCase()) > -1;
    });
  }

  if (keyword) {
    if (keywordType === 2) {
      items = filter(items, (each) => {
        return each.externalItemId === keyword;
      });
    } else if (keywordType === 3) {
      items = filter(items, (each) => {
        return each.itemSku?.toLowerCase()?.indexOf(keyword?.toLowerCase()) > -1;
      });
    } else if (keywordType === 4) {
      items = filter(items, (each) => {
        return each.skuInfo.some(
          (e) => e.sellerSku?.toLowerCase()?.indexOf(keyword?.toLowerCase()) > -1,
        );
      });
    }
  }
  if (tagIds && tagIds.length > 0) {
    items = filter(items, (each) => {
      return each.skuInfo.some((e) =>
        e.tagSimpleData.some((tag) => tagIds.includes(Number(tag.tagId))),
      );
    });
  }
  if (categoryUniqueIds && categoryUniqueIds.length > 0) {
    items = filter(items as unknown as ItemV5[], (each) => {
      return categoryUniqueIds.includes(each.categoryUniqueId);
    }) as unknown as T[];
  }
  return items;
};

export const searchInItemScope = <T extends ItemSelectV2.Item>(
  items: T[],
  searchParams: SearchParams,
): Promise<T[]> => {
  if (searchParams.keywordType === 1) {
    searchParams.name = searchParams.keyword;
  }
  return new Promise((resolve, reject) => {
    if (searchParams?.storeScopes && searchParams?.storeScopes?.length > 0) {
      // 异步
      getGroupByStores()
        .then((res) => {
          const storeIds = convertStoreScopesToIds(searchParams.storeScopes!, res);
          items = filter(items, (each) => {
            return storeIds.some((e) => String(e) === each.internalStoreId);
          });

          resolve(searchInSync(items, searchParams));
        })
        .catch(reject);
    } else {
      // 同步
      resolve(searchInSync(items, searchParams));
    }
  });
};
